import React from "react";
import { IAhRecord, IDoctor, IPlan } from "../../interfaces/api";
import { AiOutlineCheck, AiOutlineClose } from "react-icons/ai";

const DoctorDrugInfo = ({
  doctor,
  planData,
}: {
  doctor: IDoctor;
  planData: IPlan;
}) => {
  function isPbpInAhRecords(
    pbpToCheck: string,
    ahRecords: IAhRecord[]
  ): boolean {
    for (const ahRecord of ahRecords) {
      if (ahRecord.pbp.some((plan) => plan.pbpid === pbpToCheck)) {
        return true;
      }
    }
    return false;
  }
  function ishcodeInAhRecords(
    hcodeToCheck: string,
    ahRecords: IAhRecord[]
  ): boolean {
    for (const ahRecord of ahRecords) {
      if (ahRecord.pbp.some((plan) => plan.healthPlanID === hcodeToCheck)) {
        return true;
      }
    }
    return false;
  }

  const pbpToCheck = planData.pbp;
  const hcodeToCheck = planData.hcode;

  const isPbpFound = isPbpInAhRecords(pbpToCheck, doctor.ahRecords);
  const isHcodeFound = ishcodeInAhRecords(hcodeToCheck, doctor.ahRecords);

  const isCovered = isPbpFound && isHcodeFound ? true : false;

  return (
    <div
      style={{
        backgroundColor: "#D3E1F0",
        padding: "8px 16px",
        borderRadius: "5px",
        marginBottom: "16px",
        marginTop: "16px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div>
        <h4 className="secondary-color" style={{ fontSize: "18px" }}>
          {doctor.nppes.firstName} {doctor.nppes.lastName},{" "}
          {doctor.nppes.suffix}
        </h4>
        <div>{doctor.specialities[0].desc}</div>
      </div>
      {isCovered ? (
        <div style={{ display: "flex", alignItems: "center" }}>
          <AiOutlineCheck style={{ color: "#215732", fontSize: 18 }} />
          <div style={{ paddingLeft: 8 }}>covered</div>
        </div>
      ) : (
        <div style={{ display: "flex", alignItems: "center" }}>
          <AiOutlineClose style={{ color: "#C23A25", fontSize: 18 }} />
          <div style={{ paddingLeft: 8 }}>not covered</div>
        </div>
      )}
    </div>
  );
};

export default DoctorDrugInfo;
